module.exports = __webpack_public_path__ + "assets/img/wolf-hit.e6de33a7.png";